<template>
  <v-main>
    <RecordDetailsDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
    />
  </v-main>
</template>

<script>
import { go } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from './paperman-columns'
import RecordDetailsDialog from './RecordDetailsDialog.vue'

export default {
  pageTitle: 'Histórico de Objetos',
  components: {
    GenericReport,
    RecordDetailsDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Histórico de Objetos',
        code: 'paperman',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'DateRange',
            showInMenu: true
          },
          {
            type: 'Org',
            prefix: 'orgCode',
            useCodes: true,
            noSuffix: true,
            showInMenu: true
          },
          {
            type: 'Keywords',
            prefix: 'login',
            label: 'Login',
            showInMenu: true
          },
          {
            type: 'PapermanSubject',
            prefix: 'subjectType',
            noSuffix: true,
            label: 'Tipo do objeto',
            showInMenu: true
          },
          {
            type: 'Keywords',
            prefix: 'subjectId',
            noSuffix: true,
            label: 'ID do objeto',
            showInMenu: true
          },
          {
            type: 'PapermanAction',
            prefix: 'action',
            noSuffix: true,
            label: 'Ação no objeto',
            showInMenu: true
          }
        ]
      },

      adapterSpec: fullSpec
    }
  },
  methods: {
    async fetchData(apiParams) {
      let rows = await go('GET', '/paperman/history', {
        ...apiParams,
        count: true
      })
      return rows
    },

    selectRow({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
